// These ISO countries are not included in backend countries list

export const hiddenCountriesMap: {
    [k: string]: string;
} = {
    AQ: 'Antarctica',
    BV: 'Bouvet Island',
    IO: 'British Indian Ocean Territory',
    CX: 'Christmas Island',
    HM: 'Heard Island and McDonald Islands',
    NR: 'Nauru',
    NF: 'Norfolk Island',
    PN: 'Pitcairn',
    GS: 'South Georgia and the South Sandwich Islands',
    TK: 'Tokelau',
    UM: 'United States Minor Outlying Islands',
    AX: 'Åland Islands',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    CW: 'Curaçao',
    SX: 'Sint Maarten (Dutch part)',
    SS: 'South Sudan',
    XK: 'Kosovo',
};

export const backendNonIsoLangsMap: {
    [k: string]: string;
} = {
    AW: 'Awadhi',
    B1: 'Bhojpuri',
    B2: 'Maithili',
    BL: 'Balochi',
    CB: 'Cebuano',
    DK: 'Dakhini',
    IN: 'Indonesian',
    IW: 'Hebrew',
    JI: 'Yiddish',
    JW: 'Javanese',
    KB: 'Kabyle',
    LM: 'Lombard',
    MO: 'Moldavian',
    MU: 'Makhuwa',
    MW: 'Marwari',
    RI: 'Rifian',
    SH: 'Serbo-Croatian',
    TM: 'Tuareg',
    TZ: 'Tamazight',
};

// These language are not included in backend languages list
export const isoMissingLangsMap: {
    [k: string]: string;
} = {
    AE: 'Avestan',
    AN: 'Aragonese',
    AV: 'Avaric',
    BM: 'Bambara',
    BS: 'Bosnian',
    CH: 'Chamorro',
    CR: 'Cree',
    CU: 'Church Slavic',
    CV: 'Chuvash',
    DV: 'Maldivian',
    EE: 'Ewe',
    FF: 'Fulah',
    GV: 'Manx',
    HE: 'Hebrew (modern)',
    HO: 'Hiri Motu',
    HZ: 'Herero',
    ID: 'Indonesian',
    IG: 'Igbo',
    II: 'Nuosu',
    IO: 'Ido',
    IU: 'Inuktitut',
    JV: 'Javanese',
    KG: 'Kongo',
    KJ: 'Kwanyama',
    KR: 'Kanuri',
    KV: 'Komi',
    KW: 'Cornish',
    LG: 'Ganda',
    LI: 'Limburgish',
    LU: 'Luba-Katanga',
    MH: 'Marshallese',
    NB: 'Bokmål',
    ND: 'North Ndebele',
    NG: 'Ndonga',
    NN: 'Norwegian Nynorsk',
    NR: 'South Ndebele',
    NV: 'Navajo',
    NY: 'Nyanja',
    OJ: 'Ojibwa',
    OS: 'Ossetian',
    PI: 'Pali',
    SC: 'Sardinian',
    SE: 'Northern Sami',
    TY: 'Tahitian',
    VE: 'Venda',
    WA: 'Walloon',
    YI: 'Yiddish',
    ZA: 'Zhuang',
};
